import { get, put } from './';

export const getOrganization = ({ id }) => get(`organizations/${id}`);
export const updateOrganization = (organizationId, payload) =>
  put(`organizations/${organizationId}`, payload);
